import { render, staticRenderFns } from "./CallOutCTA.vue?vue&type=template&id=182be5e0&scoped=true&"
var script = {}
import style0 from "./CallOutCTA.vue?vue&type=style&index=0&id=182be5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182be5e0",
  null
  
)

export default component.exports